<div *ngIf="totalItems > 0" class="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6">
  <!-- Informations sur les éléments -->
  <div *ngIf="showInfo" class="flex flex-1 justify-between sm:hidden">
    <div class="text-sm text-gray-700">
      Affichage de <span class="font-medium">{{ startItem }}</span> à <span class="font-medium">{{ endItem }}</span>
      sur <span class="font-medium">{{ totalItems }}</span> résultats
    </div>
  </div>

  <div *ngIf="showInfo" class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
    <div>
      <p class="text-sm text-gray-700">
        Affichage de <span class="font-medium">{{ startItem }}</span> à <span class="font-medium">{{ endItem }}</span>
        sur <span class="font-medium">{{ totalItems }}</span> résultats
      </p>
    </div>
    
    <!-- Navigation de pagination -->
    <div>
      <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
        <!-- Bouton Précédent -->
        <button
          (click)="previousPage()"
          [disabled]="!hasPreviousPage"
          class="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.bg-gray-50]="!hasPreviousPage"
          [class.text-gray-300]="!hasPreviousPage">
          <span class="sr-only">Précédent</span>
          <lucide-icon [img]="ChevronLeftIcon" [size]="16"></lucide-icon>
        </button>

        <!-- Numéros de pages -->
        <ng-container *ngFor="let page of visiblePages">
          <button
            *ngIf="page !== -1"
            (click)="goToPage(page)"
            [class]="page === currentPage 
              ? 'relative z-10 inline-flex items-center bg-primary px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'
              : 'relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'">
            {{ page }}
          </button>
          
          <!-- Points de suspension -->
          <span
            *ngIf="page === -1"
            class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0">
            ...
          </span>
        </ng-container>

        <!-- Bouton Suivant -->
        <button
          (click)="nextPage()"
          [disabled]="!hasNextPage"
          class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.bg-gray-50]="!hasNextPage"
          [class.text-gray-300]="!hasNextPage">
          <span class="sr-only">Suivant</span>
          <lucide-icon [img]="ChevronRightIcon" [size]="16"></lucide-icon>
        </button>
      </nav>
    </div>
  </div>
</div>
